module.exports = __webpack_public_path__ + "static/media/carly.3611f418.jpg";